import { render, staticRenderFns } from "./UserRight.vue?vue&type=template&id=a3ca3ef2&scoped=true"
import script from "./UserRight.vue?vue&type=script&lang=js"
export * from "./UserRight.vue?vue&type=script&lang=js"
import style0 from "./UserRight.vue?vue&type=style&index=0&id=a3ca3ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca3ef2",
  null
  
)

export default component.exports